import gql from 'graphql-tag';
import _ from 'lodash';
import moment from 'moment';

import { getLanguageCode } from 'js/lib/language';
import path from 'js/lib/path';

export function getStartMoment(course: $TSFixMe) {
  return course.startDate != null ? moment.utc(course.startDate) : null;
}
getStartMoment.fragment = gql`
  fragment CoursesV1_getStartMoment on CoursesV1 {
    startDate
  }
`;

export function isSpark(course: $TSFixMe) {
  return course.courseType != null && course.courseType.indexOf('v1') === 0;
}
isSpark.fragment = gql`
  fragment CoursesV1_isSpark on CoursesV1 {
    courseType
  }
`;

export function isOnDemand(course: $TSFixMe) {
  return course.courseType === 'v2.ondemand' || course.courseType === 'v2.capstone';
}
isOnDemand.fragment = gql`
  fragment CoursesV1_isOnDemand on CoursesV1 {
    courseType
  }
`;

export function getLink(course: $TSFixMe) {
  return path.join('/', isOnDemand(course) ? 'learn' : 'course', course.slug);
}
getLink.fragment = gql`
  fragment CoursesV1_getLink on CoursesV1 {
    slug
    ...CoursesV1_isOnDemand
  }
  ${isOnDemand.fragment}
`;

export function getDesc60(course: $TSFixMe) {
  const descLen = 60;
  const { description } = course;
  if (description && description.length > descLen && description.indexOf('.', descLen) !== -1) {
    return description.slice(0, description.indexOf('.', descLen) + 1);
  } else {
    return description;
  }
}
getDesc60.fragment = gql`
  fragment CoursesV1_getDesc60 on CoursesV1 {
    description
  }
`;

export const RECENT_COURSE_CUTOFF = 7;
export function sortCourses(courses: $TSFixMe, options: $TSFixMe) {
  const recentCutoff = moment().subtract(RECENT_COURSE_CUTOFF, 'days');
  const boostPrimaryLanguage = options && options.boostPrimaryLanguage;

  const onDemandCourses = courses.filter((course: $TSFixMe) => course.isOnDemand);

  const upcomingCourses = _.sortBy(
    _.filter(courses, (course) => course.startMoment && course.startMoment.isAfter(recentCutoff)),
    (course) => course.startMoment
  );

  const pastCourses = _.sortBy(
    _.filter(courses, (course) => course.startMoment && course.startMoment.isBefore(recentCutoff)),
    (course) => -1 * course.startMoment
  );

  const coursesWithoutStartDate = courses.filter((course: $TSFixMe) => course.startMoment === undefined);

  const activeCourses = _.union(onDemandCourses, upcomingCourses);
  const activeCoursesInSelectLanguage = boostPrimaryLanguage
    ? activeCourses.filter(
        (course) => course.primaryLanguages && course.primaryLanguages.indexOf(getLanguageCode()) > -1
      )
    : activeCourses;

  return _.union(activeCoursesInSelectLanguage, activeCourses, pastCourses, coursesWithoutStartDate);
}
sortCourses.fragment = gql`
  fragment CoursesV1_sortCourses on CoursesV1 {
    primaryLanguages
    ...CoursesV1_getStartMoment
    ...CoursesV1_isOnDemand
  }
  ${getStartMoment.fragment}
  ${isOnDemand.fragment}
`;
